module.exports = __webpack_public_path__ + "img/email.a00f511f.svg";